import MidiToAudioChain from '../core/MidiToAudioChain';
class InstrumentRackBranch {
    constructor() {
        this.keyRange = [0, 127];
        this.chain = new MidiToAudioChain();
    }
    input() { return this.chain.input(); }
    output() { return this.chain.output(); }
    triggerAttack(note, time, velocity) {
        if (note >= this.keyRange[0] && note <= this.keyRange[1]) {
            this.chain.input().triggerAttack(note, time, velocity);
        }
    }
    triggerRelease(time, note) {
        if (note >= this.keyRange[0] && note <= this.keyRange[1]) {
            this.chain.input().triggerRelease(time, note);
        }
    }
    insert(device, position) {
        this.chain.insert(device, position);
    }
}
export default InstrumentRackBranch;
//# sourceMappingURL=InstrumentRackBranch.js.map